<template>
    <v-container class="grey-lighten-3 full-height">
        <v-row justify="center">
            <v-col cols="12" xl="10" lg="11" md="12">
                <v-sheet class="report-paper pa-5 mx-auto" elevation="3" id="printable-area">

                <div class="header-section d-flex justify-space-between mb-6 lines">
                    <div class="company-logo-area d-flex align-center">
                        <div class="logo-placeholder mr-4">
                        </div>
                        <div>
                            <v-img :src="`${getFileServerUrl.replace(/\/$/, '')}/${getSaleInvoiceDelivery?.branch?.company?.logo || 'uploads/demo_images/user.png'}`" width="200" height="100" class="rounded" />
                        </div>
                    </div>

                    <div class="company-address text-caption text-right">
                        <h1 class="company-name text-h5 font-weight-bold text-uppercase">
                            {{ getSaleInvoiceDelivery?.branch?.company?.name }}
                        </h1>
                        <h1 class="text-subtitle-1 text-end">
                            {{ getSaleInvoiceDelivery?.branch?.company?.address }}
                        </h1>
                    </div>
                </div>

                <div class="text-center mb-6">
                    <h2 class="report-title text-h6 font-weight-bold text-decoration-underline">
                        DELIVERY INVOICE
                    </h2>
                </div>
                <!-- Main Content -->
                <div class="meta-info-box mb-4">
                    <div class="d-flex" style="border-bottom: 1px solid #000;">
                        <div class="meta-item d-flex align-center" style="width: 100%;">
                            <span class="meta-label pl-2">Customer Name:</span>
                            <span class="meta-value pl-2">{{ deliveryCustomerNames }}</span>
                        </div>
                    </div>
                    <div class="d-flex">
                        <div class="meta-item d-flex align-center" style="width: 50%; border-right: 1px solid #000; border-bottom:1px solid #000">
                            <span class="meta-label pl-2">Delivery No:</span>
                            <span class="meta-value pl-2 font-weight-bold">{{ getSaleInvoiceDelivery?.code }}</span>
                        </div>  
                        
                        <div class="meta-item d-flex align-center" style="width: 50%; border-bottom:1px solid #000">
                            <span class="meta-label pl-2">Delivery Date:</span>
                            <span class="meta-value pl-2">{{ getSaleInvoiceDelivery?.delivery_date }}</span>
                        </div>
                    </div>
                    <div class="d-flex" style="border-bottom: 1px solid #000;">
                        <div class="meta-item d-flex align-center" style="width: 50%; border-right: 1px solid #000;">
                            <span class="meta-label pl-2">From Port:</span>
                            <span class="meta-value pl-2">{{ getSaleInvoiceDelivery?.from_port?.name }}</span>
                        </div>
                        <div class="meta-item d-flex align-center" style="width: 50%;">
                            <span class="meta-label pl-2">To Port:</span>
                            <span class="meta-value pl-2">{{ getSaleInvoiceDelivery?.to_port?.name }}</span>
                        </div>
                    </div>
                    <div class="d-flex" style="border-bottom: 1px solid #000;">
                        <div class="meta-item d-flex align-center" style="width: 50%; border-right: 1px solid #000;">
                            <span class="meta-label pl-2">Total Item:</span>
                            <span class="meta-value pl-2">{{ getSaleInvoiceDelivery?.total_item }}</span>
                        </div>
                        <div class="meta-item d-flex align-center" style="width: 50%;">
                            <span class="meta-label pl-2">Container No:</span>
                            <span class="meta-value pl-2">{{ getSaleInvoiceDelivery?.container_no }}</span>
                        </div>
                    </div>
                    <div class="d-flex" style="border-bottom: 1px solid #000;">
                        <div class="meta-item d-flex align-center" style="width: 50%; border-right: 1px solid #000;">
                            <span class="meta-label pl-2">MBL No:</span>
                            <span class="meta-value pl-2">{{ getSaleInvoiceDelivery?.mbl_no }}</span>
                        </div>
                        <div class="meta-item d-flex align-center" style="width: 50%;">
                            <span class="meta-label pl-2">HBL No:</span>
                            <span class="meta-value pl-2">{{ getSaleInvoiceDelivery?.hbl_no }}</span>
                        </div>
                    </div>
                    <div class="d-flex">
                        <div class="meta-item d-flex align-center" style="width: 50%; border-right: 1px solid #000;">
                            <span class="meta-label pl-2">MBL / HBL Date:</span>
                            <span class="meta-value pl-2">{{ getSaleInvoiceDelivery?.mbl_date }}</span>
                        </div>
                        <div class="meta-item d-flex align-center" style="width: 50%;">
                        </div>
                    </div>
                    <!-- <div class="d-flex">
                        <div class="meta-item d-flex align-center" style="width: 50%; border-right: 1px solid #000;">
                            <span class="meta-label pl-2">Buyer Name:</span>
                            <span class="meta-value pl-2">{{ getSaleInvoiceDelivery?.supplier?.customer_name }}</span>
                        </div>
                        <div class="meta-item d-flex align-center" style="width: 50%;">
                            <span class="meta-label pl-2">Shipper Name :</span>
                            <span class="meta-value pl-2">{{ getSaleInvoiceDelivery?.supplier?.customer_name }}</span>
                        </div>
                    </div> -->
                </div>

                <!-- Depreciation Details Table -->
                <div class="table-container mb-6">
                    <table class="dep-table">
                        <thead>
                            <tr>
                                <th class="text-center" style="width: 40px;">SL</th>
                                <th>Order No</th>
                                <th>Product Name</th>
                                <th>Category</th>
                                <!-- <th>Calc. Type</th> -->
                                <th>Order Qty</th>
                                <th>Delivery Qty</th>
                                <!-- <th>Product Qty</th> -->
                                <th>CBM Meas.</th>
                                <th>CBM</th>
                                <!-- <th>Rate</th>
                                <th>Amount</th> -->
                                <th>Remarks</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(detail, index) in getSaleInvoiceDelivery?.details" :key="detail.id">
                                <td class="text-center">{{ index + 1 }}</td>
                                <td class="text-left">{{ detail.sale_order?.code }}</td>
                                <td class="text-left">{{ detail.product?.name }}</td>
                                <td class="text-left">{{ categoryLabel(detail?.sale_order_detail?.category) }}</td>
                                <!-- <td class="text-left">{{ calTypeLabel(detail?.sale_order_detail?.calc_type) }}</td> -->
                                <td class="text-right">{{ detail?.sale_order_detail?.bag }}</td>
                                <td class="text-right">{{ detail.qty }}</td>
                                <!-- <td class="text-right">{{ detail.product_qty }}</td> -->
                                <td class="text-right">{{ detail?.sale_order_detail?.cbm_meas }}</td>
                                <td class="text-right">{{ detail?.sale_order_detail?.cbm }}</td>
                                <!-- <td class="text-right">{{ detail.rate }}</td>
                                <td class="text-right">{{ detail.total }}</td> -->
                                <td class="text-right">{{ detail.remarks }}</td>
                            </tr>
                        </tbody>
                        <tfoot>
                        <tr>
                          <th colspan="4" class="text-center">TOTAL</th>
                          <th class="text-right">{{ getSaleInvoiceDelivery?.details.reduce((prev, cur) => { return +prev + +(cur?.sale_order_detail?.bag??0) }, 0) ?? 0 }}</th>
                          <th class="text-right">{{ getSaleInvoiceDelivery?.details.reduce((prev, cur) => { return +prev + +(cur.qty??0) }, 0) ?? 0 }}</th>
                          <!-- <th class="text-right">{{ getSaleInvoiceDelivery?.details.reduce((prev, cur) => { return (+prev) + (+(cur.product_qty??0)) }, 0) ?? 0 }}</th> -->
                          <th></th>
                          <th></th>
                          <!-- <th></th>
                          <th>{{ parseFloat(getSaleInvoiceDelivery?.details.reduce((prev, cur) => { return +prev + +cur.total }, 0) ?? 0).toFixed(2) }}</th> -->
                          <th></th>
                        </tr>
                      </tfoot>
                    </table>
                </div>

                <v-row class="mt-16">
                    <v-col cols="4">
                        <p style="border-top: 1px solid #555; width:200px; margin: 0 auto; color: #333; text-align:center">
                            <span>Received By</span>
                        </p>
                    </v-col>
                    <v-col cols="4"></v-col>
                    <v-col cols="4">
                        <p style="border-top: 1px solid #555; width: 200px; margin: 0 auto; color: #333; text-align:center">
                            <span>Send By</span>
                        </p>
                    </v-col>
                </v-row>

                <v-row>
                    <v-col cols="12" class="text-center mt-4">
                        <span class="text-caption">
                            <hr>
                            UAE Address: Dnata Building Freight Gate 5 Building, Office no 210, 2nd Floor, Block E, Dubai Airport Free Zone Authorities Premises, DAFZA, Dubai. 
                            <br>
                            Cell: +971 507155639& +971 566491905
                            <br>
                            Dhaka Office: House Name: Sahnaz Sultana house no: 14 Road no: 32 Lift: 6-a Gulshan-1, Dhaka-1212 , Bnagladesh. 
                            <br> Cell: +88 01898461015& +88 01330456380
                        </span>
                    </v-col>
                </v-row>
                </v-sheet>
            </v-col>
        </v-row>
        <!-- Action Toolbar (Hidden on Print) -->
        <v-row class="d-print-none mb-4" justify="center">
            <v-col cols="12" md="8" lg="9" class="d-flex justify-center gap-2">
                <!-- <v-btn color="success" prepend-icon="mdi-download" @click="downloadPDF">
                    Print PDF
                </v-btn> -->
                <v-btn color="success" prepend-icon="mdi-download" @click="printInvoice">
                  Print PDF
              </v-btn>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import html2pdf from "html2pdf.js";
import { shipModeLabel, payModeLabel, categoryLabel, calTypeLabel } from "@/plugins/helpers.js";

export default {
    name: "Sales",

    data: () => ({
        mainId: null,
        getSaleInvoiceDelivery: null,
    }),
    
    watch: {},

    created() {
        const id = this.$route.query.id;
        this.mainId = id;
        this.$store.dispatch("getInvSalesInvoiceDeliveryById", id).then((response) => {
            this.getSaleInvoiceDelivery = response;
        });
    },

    computed: {
        getCurrentCompany() {
            this.companyInfo = this.$store.getters.getCurrentCompany;
            return this.$store.getters.getCurrentCompany;
        },
        getFileServerUrl() {
            return this.$store.getters.getFileServerUrl;
        },
        deliveryCustomerNames() {
            const details = this.getSaleInvoiceDelivery?.details || [];
            const names = [...new Set(
                details
                    .map((d) => d?.sale_order?.customer?.customer_name)
                    .filter(Boolean)
            )];
            return names.length ? names.join(", ") : "—";
        },
    },  

    methods: {
        categoryLabel,
        calTypeLabel,
        formatDate(date) {
            if (!date) return "-";
            const d = new Date(date);
            return `${d.getDate().toString().padStart(2, "0")}/${(d.getMonth() + 1)
                .toString()
                .padStart(2, "0")}/${d.getFullYear()}`;
        },
        formatDateTime(dateTime) {
            if (!dateTime) return "-";
            const d = new Date(dateTime);
            return `${this.formatDate(dateTime)} ${d.toLocaleTimeString()}`;
        },
        formatNumber(num) {
            return num ? Number(num).toFixed(2) : "0.00";
        },
        async downloadPDF() {
            const element = document.getElementById("printable-area");
            const opt = {
                margin: [0.5, 0.5],
                filename: `sale-delivery-${this.getSaleInvoiceDelivery?.code}.pdf`,
                image: { type: "jpeg", quality: 0.98 },
                html2canvas: { scale: 2, useCORS: true },
                jsPDF: { unit: "cm", format: "a4", orientation: "portrait" },
            };
            await html2pdf().set(opt).from(element).save();
        },
        async printInvoice() {
            const esc = (v) =>
                v === null || v === undefined
                ? ""
                : String(v)
                    .replace(/&/g, "&amp;")
                    .replace(/</g, "&lt;")
                    .replace(/>/g, "&gt;");

            const details = this.getSaleInvoiceDelivery?.details || [];

            const totalQty = details.reduce((s, x) => s + (+x.qty || 0), 0);
            const totalOrderQty = details.reduce((s, x) => s + (+x?.sale_order_detail?.bag || 0), 0);
            const totalProductQty = details.reduce((s, x) => s + (+x.product_qty || 0), 0);
            const totalAmount = details.reduce((s, x) => s + (+x.total || 0), 0);

            const logoSrc = this.getCurrentCompany?.logo_thumb
                ? `${this.getFileServerUrl.replace(/\/$/, '')}/${this.getCurrentCompany.logo_thumb}`
                : `${this.getFileServerUrl.replace(/\/$/, '')}/uploads/demo_images/user.png`;


            const html = `
                <!doctype html>
                <html>
                <head>
                <meta charset="utf-8"/>
                <meta name="viewport" content="width=device-width, initial-scale=1"/>
                <title>Gate Pass Invoice - ${esc(this.getSaleInvoiceDelivery?.code)}</title>

                <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.2/dist/css/bootstrap.min.css" rel="stylesheet"/>

                <style>
                    body { font-family: Arial, Helvetica, sans-serif; margin: 0; color: #111; }
                    .paper { max-width: 280mm; margin: 10px auto; background: #fff; padding: 18px; box-sizing: border-box; }
                    .company-logo img { max-width: 200px; height: auto; }
                    .meta-box { border: 1px solid #000; padding: 0; overflow: hidden; }
                    .meta-row { display: flex; width: 100%; }
                    .meta-cell { flex: 1; padding: 8px; border-right: 1px solid #000; border-bottom:1px solid #000; box-sizing: border-box; height: 40px; display:flex; align-items:center; }
                    .meta-cell:last-child { border-right: none; }
                    table.invoice-table { width: 100%; border-collapse: collapse; font-size: 13px; margin-top: 12px; }
                    table.invoice-table th, table.invoice-table td { border: 1px solid #000; padding: 6px 8px; vertical-align: top; }
                    table.invoice-table th { background: #f0f0f0; }
                    .totals { margin-top: 12px; }
                    .signature { margin-top: 36px; display:flex; justify-content:space-between; align-items:center; }
                    .sig-line { width: 200px; border-top: 1px solid #555; text-align:center; padding-top:6px; }
                    .watermark {
                        position: absolute;
                        top: 50%;
                        left: 50%;
                        transform: translate(-50%, -50%);
                        background-image: url('${this.getCurrentCompany.logo_thumb ? this.getFileServerUrl + this.getCurrentCompany.logo_thumb : '@/assets/image/logo.png'}');
                        background-repeat: no-repeat;
                        background-position: center;
                        background-size: contain;
                        width: 80%; 
                        height: 80%;
                        opacity: 0.1;
                        z-index: 999;
                        pointer-events: none;
                    }
                    @media print {
                        body * { visibility: hidden; }
                        #printable, #printable * { visibility: visible; }
                        #printable { position: absolute; left: 0; top: 0; width: 100%; padding: 8px; }
                        @page { size: A4 portrait; margin: 0.5cm; }
                    }
                    </style>
                </head>

                <body>
                    <div id="printable" class="paper position-relative">
                    <div class="watermark"></div>
                    <!-- Header Section -->
                    <div class="d-flex justify-content-between align-items-center mb-3">
                        <div class="company-logo text-end company-logo">
                            <img src="${logoSrc}" alt="Logo" class="img-fluid" />
                        </div>
                        <div>
                            <h5 class="mb-0 text-uppercase text-end">${esc(this.getCurrentCompany?.name || this.companyInfo?.name || '')}</h5>
                            <p class="mb-0 text-end" style="font-size:14px">${esc(this.getCurrentCompany?.address || this.companyInfo?.address || '')}</p>
                        </div>
                    </div>

                    <h6 class="text-center mb-3"><strong>DELIVERY INVOICE</strong></h6>

                    <!-- Meta Info -->
                    <div class="meta-box">

                        <div class="meta-row">
                            <div class="meta-cell" style="flex: 1;">
                                <strong>Customer Name: </strong> ${esc(this.deliveryCustomerNames)}
                            </div>
                        </div>
                        <div class="meta-row">
                            <div class="meta-cell">
                                <strong>Delivery No: </strong> ${esc(this.getSaleInvoiceDelivery?.code)}
                            </div>
                            <div class="meta-cell">
                                <strong>Delivery Date: </strong> ${esc(this.getSaleInvoiceDelivery?.delivery_date)}
                            </div>
                        </div>
                        <div class="meta-row">
                            <div class="meta-cell">
                                <strong>From Port: </strong> ${esc(this.getSaleInvoiceDelivery?.from_port?.name)}
                            </div>
                            <div class="meta-cell">
                                <strong>To Port: </strong> ${esc(this.getSaleInvoiceDelivery?.to_port?.name)}
                            </div>
                        </div>
                        <div class="meta-row">
                            <div class="meta-cell">
                                <strong>Total Item: </strong> ${esc(this.getSaleInvoiceDelivery?.total_item)}
                            </div>
                            <div class="meta-cell">
                                <strong>Container No: </strong> ${esc(this.getSaleInvoiceDelivery?.container_no)}
                            </div>
                        </div>
                        <div class="meta-row">
                            <div class="meta-cell">
                                <strong>MBL No: </strong> ${esc(this.getSaleInvoiceDelivery?.mbl_no)}
                            </div>
                            <div class="meta-cell">
                                <strong>HBL No: </strong> ${esc(this.getSaleInvoiceDelivery?.hbl_no)}
                            </div>
                        </div>
                        <div class="meta-row">
                            <div class="meta-cell">
                                <strong>MBL / HBL Date: </strong> ${esc(this.getSaleInvoiceDelivery?.mbl_date)}
                            </div>
                            <div class="meta-cell">
                                
                            </div>
                        </div>

                    </div>

                    <!-- Table -->
                    <table class="invoice-table">
                        <thead>
                        <tr>
                            <th>SL</th>
                            <th>Order No</th>
                            <th>Product Name</th>
                            <th>Category</th>
                            <th>Order Qty</th>
                            <th>Delivery Qty</th>
                            <th>CBM Meas.</th>
                            <th>CBM</th>
                            <th>Remarks</th>
                        </tr>
                        </thead>

                        <tbody>
                        ${details
                            .map((d, i) => `
                            <tr>
                                <td class="text-center">${i + 1}</td>
                                <td class="text-left">${esc(d.sale_order?.code)}</td>
                                <td class="text-left">${esc(d.product.name)}</td>
                                <td class="text-left">${esc(categoryLabel(d?.sale_order_detail?.category))}</td>
                                <td class="text-end">${esc(d?.sale_order_detail?.bag)}</td>
                                <td class="text-end">${esc(d.qty)}</td>
                                <td class="text-end">${esc(d?.sale_order_detail?.cbm_meas)}</td>
                                <td class="text-end">${esc(d?.sale_order_detail?.cbm)}</td>
                                <td class="text-end">${esc(d.remarks)}</td>
                            </tr>`
                            )
                            .join("")}
                        </tbody>

                        <tfoot>
                        <tr>
                            <th colspan="4" class="text-center">TOTAL</th>
                            <th class="text-end">${totalOrderQty}</th>
                            <th class="text-end">${totalQty}</th>
                            <th></th>
                            <th></th>
                            <th></th>
                        </tr>
                        </tfoot>
                    </table>

                    <div class="signature">
                        <div class="text-center">
                        <div class="sig-line">Received By</div>
                        </div>
                        <div></div>
                        <div class="text-center">
                        <div class="sig-line">Send By</div>
                        </div>
                    </div>

                    <div class="text-center mt-3 small">
                        <hr/>
                        <div>
                        UAE Address: Dnata Building Freight Gate 5 Building, Office no 210, 2nd Floor, Block E, Dubai Airport Free Zone Authorities Premises, DAFZA, Dubai.
                        <br> Cell: +971 507155639 &amp; +971 566491905
                        <br> Dhaka Office: House Name: Sahnaz Sultana house no: 14 Road no: 32 Lift: 6-a Gulshan-1, Dhaka-1212 , Bangladesh.
                        <br> Cell: +88 01898461015 &amp; +88 01330456380
                        </div>
                    </div>

                    </div>

                    </body>
                    </html>
                    `;

                    const w = window.open("", "PRINT", `width=${screen.width},height=${screen.height}`);
                    w.document.open();
                    w.document.write(html);
                    w.document.close();

                    await new Promise((res) => setTimeout(res, 400));
                    w.focus();
                    w.print();
                    w.close();
        }
        // printPage() {
        //     const printContent = document.getElementById("printable-area").innerHTML;
        //     const printWindow = window.open("", "_blank", `width=${screen.width}, height=${screen.height}, left=0, top=0`);

        //     printWindow.document.write(`
        //         <!DOCTYPE html>
        //         <html>
        //         <head>
        //             <meta charset="UTF-8">
        //             <meta name="viewport" content="width=device-width, initial-scale=1.0">
        //             <title>sale DELIVERY INVOICE</title>
        //             <link href="https://cdn.jsdelivr.net/npm/@mdi/font@7.4.47/css/materialdesignicons.min.css" rel="stylesheet">
        //             <style>
        //             body {
        //                 font-family: 'Times New Roman', serif;
        //                 background: white;
        //                 margin: 0;
        //                 padding: 20px;
        //             }
        //             .report-paper {
        //                 background-color: white;
        //                 color: black;
        //                 max-width: 100%;
        //                 width: 100%;
        //                 margin: auto;
        //             }
        //             .header-section {
        //                 display: flex;
        //                 justify-content: space-between;
        //                 align-items: flex-start;
        //                 border-bottom: 2px solid #eee;
        //                 padding-bottom: 10px;
        //                 margin-bottom: 16px;
        //             }
        //             .company-info {
        //                 flex: 1;
        //             }
        //             .company-name {
        //                 color: #333;
        //                 font-size: 20px;
        //                 font-weight: bold;
        //                 text-transform: uppercase;
        //                 margin: 0 0 4px 0;
        //             }
        //             .company-text {
        //                 font-size: 14px;
        //                 color: #555;
        //                 margin: 2px 0;
        //                 display: flex;
        //                 align-items: center;
        //             }
        //             .logo-container img {
        //                 max-height: 70px;
        //                 max-width: 150px;
        //             }
        //             .report-title {
        //                 color: #333;
        //                 font-size: 20px;
        //                 font-weight: bold;
        //                 text-align: center;
        //                 margin: 16px 0;
        //             }
        //             .meta-info-box {
        //                 border: 1px solid #000;
        //                 margin-bottom: 16px;
        //             }
        //             .meta-item {
        //                 height: 35px;
        //                 display: flex;
        //                 align-items: center;
        //             }
        //             .meta-label {
        //                 font-weight: 500;
        //                 color: #333;
        //                 padding-left: 8px;
        //             }
        //             .meta-value {
        //                 padding-left: 8px;
        //                 color: #555;
        //             }
        //             .d-flex {
        //                 display: flex;
        //             }
        //             .dep-table {
        //                 width: 100%;
        //                 border-collapse: collapse;
        //                 font-size: 14px;
        //                 margin-bottom: 24px;
        //             }
        //             .dep-table th {
        //                 background-color: #f0f0f0;
        //                 border: 1px solid #000;
        //                 padding: 8px 5px;
        //                 color: #333;
        //             }
        //             .dep-table td {
        //                 border: 1px solid #000;
        //                 padding: 8px 5px;
        //                 vertical-align: middle;
        //                 color: #555;
        //             }
        //             .text-center {
        //                 text-align: center;
        //             }
        //             .text-right {
        //                 text-align: right;  
        //             }
        //             .prepared-section {
        //                 margin-bottom: 32px;
        //                 color: #555;
        //             }
        //             .font-weight-bold {
        //                 font-weight: bold;
        //                 color: #333;
        //             }
        //             .text-caption {
        //                 font-size: 12px;
        //                 color: #666;
        //             }
        //             .lines {
        //                 border-bottom: 2px solid #eee;
        //                 padding-bottom: 10px;
        //             }
        //             @page {
        //                 margin: 0.5in;
        //                 size: letter;
        //             }
        //             @media print {
        //                 body {
        //                     -webkit-print-color-adjust: exact;
        //                     print-color-adjust: exact;
        //                     background: white !important;
        //                     padding: 0;
        //                 }
        //                 .page-header {
        //                     display: table-header-group;
        //                 }
        //                 .page-content {
        //                     display: table-row-group;
        //                 }
        //             }
        //             </style>
        //         </head>
        //         <body>
        //             ${printContent}
        //         </body>
        //         </html>
        //     `);

        //     printWindow.document.close();
        //     printWindow.moveTo(0, 0);
        //     printWindow.focus();
            
        //     setTimeout(() => {
        //         printWindow.print();
        //         printWindow.onafterprint = () => {
        //             printWindow.close();
        //         };
        //     }, 1000);
        // }
    },
};
</script>

<style scoped>
.header-section {
    display: flex;
    flex-direction: flex !important;
}
/* .company-address {
    text-align: left !important;
} */
.full-height {
    min-height: 100vh;
}
.grey-lighten-3 {
    background-color: #eeeeee !important;
}
.report-paper {
    background-color: white;
    color: black;
    font-family: 'Times New Roman', serif;
    max-width: 280mm;
    width: 100%;
    min-height: 297mm;
}
.company-name {
    color: #444;
    letter-spacing: 1px;
}
.report-title {
    text-decoration: underline;
    text-underline-offset: 4px;
}
.meta-info-box {
    border: 1px solid #000;
}
.meta-item {
    height: 35px;
}
.meta-label {
    font-weight: 500;
    color: #333;
}
.dep-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 14px;
}
.dep-table th {
    background-color: #e0e0e0;
    border: 1px solid #000;
    padding: 6px 5px;
}
.dep-table td {
    border: 1px solid #000;
    padding: 6px 5px;
    vertical-align: top;
}
.lines {
    border-bottom: 1px solid #ccc;
    padding-bottom: 5px;
}
.text-center {
    text-align: center;
}
.text-right {
    text-align: right;
}
.gap-2 {
    gap: 8px;
}

/* Print Styles */
@media print {
    body * {
            visibility: hidden;
    }
    #printable-area,
    #printable-area * {
            visibility: visible;
    }
    #printable-area {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        padding: 15px;
    }
    .report-paper {
        box-shadow: none !important;
    }
    @page {
        size: A4 portrait;
        margin: 0.5cm;
    }
    .d-print-none {
        display: none !important;
    }
}

</style>